module.exports = __webpack_public_path__ + "img/naira-icon.32a47540.svg";